import { Grid } from "@mui/material";
import React from "react";
import Controls from "../../../../components/form/controls/Controls";

const renderHead = (item, index) => (
  <th style={{ textAlign: "center" }} key={index}>
    {item}
  </th>
);

const renderColumnObject = (value) => {
  if (typeof value === "object" && value !== null) {
    return JSON.stringify(value);
  }

  return value;
};

const IntentValueTable = ({
  availableSlotNames,
  intentScriptValues,
  handleEdit,
  handleScriptValueRemove,
}) => {
  return (
    <Grid container>
      <div className="col-12">
        <div className="card" style={{ marginBottom: "0px" }}>
          <div className="card__body">
            <div className="table-wrapper">
              <table style={{ overflow: "hidden", minWidth: "max-content" }}>
                {availableSlotNames && renderHead ? (
                  <thead>
                    <tr>
                      {availableSlotNames.map((item, index) => {
                        return renderHead(item, index);
                      })}
                      <th style={{ textAlign: "center" }}>Action</th>
                    </tr>
                  </thead>
                ) : null}
                <tbody>
                  {intentScriptValues.map((slot, index) => (
                    <tr key={index} style={{ textTransform: "-moz-initial" }}>
                      {availableSlotNames.map((slotKey, indexValueKey) => (
                        <td key={indexValueKey} style={{ textAlign: "center" }}>
                          {renderColumnObject(slot[slotKey])}
                        </td>
                      ))}

                      <td style={{ textAlign: "center" }}>
                        <Controls.Button
                          variant="outlined"
                          text="edit"
                          color="warning"
                          onClick={() => handleEdit({ ...slot })}
                        />
                        <Controls.Button
                          variant="outlined"
                          text="remove"
                          color="error"
                          onClick={() => handleScriptValueRemove(slot.fakeId)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default IntentValueTable;
